export const TRIGGER_SUGGEST = {
  id: 'editor.action.triggerSuggest',
  title: '',
};
